var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEntity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1582",
    "data-name": "Group 1582",
    transform: "translate(-13178 -4997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5793",
    "data-name": "Rectangle 5793",
    transform: "translate(13178 4997)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "work_FILL0_wght200_GRAD0_opsz24",
    d: "M122.108-779.121a2.042,2.042,0,0,1-1.5-.6,2.042,2.042,0,0,1-.6-1.5v-12.748a2.042,2.042,0,0,1,.6-1.5,2.042,2.042,0,0,1,1.5-.6h5.722v-1.807a2.042,2.042,0,0,1,.6-1.5,2.042,2.042,0,0,1,1.5-.6h3.614a2.042,2.042,0,0,1,1.5.6,2.042,2.042,0,0,1,.6,1.5v1.807h5.722a2.042,2.042,0,0,1,1.5.6,2.042,2.042,0,0,1,.6,1.5v12.748a2.042,2.042,0,0,1-.6,1.5,2.042,2.042,0,0,1-1.5.6Zm0-1.3h19.273a.767.767,0,0,0,.552-.251.768.768,0,0,0,.251-.552v-12.748a.768.768,0,0,0-.251-.552.768.768,0,0,0-.552-.251H122.108a.768.768,0,0,0-.552.251.768.768,0,0,0-.251.552v12.748a.768.768,0,0,0,.251.552A.767.767,0,0,0,122.108-780.426Zm7.027-15.659h5.22v-1.807a.767.767,0,0,0-.251-.552.768.768,0,0,0-.552-.251h-3.614a.768.768,0,0,0-.552.251.767.767,0,0,0-.251.552Zm-7.83,15.659v0Z",
    transform: "translate(13058 5799.61)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntity);
export default __webpack_public_path__ + "static/media/entity.974ffb74e4d73910d8b1dd950613e23e.svg";
export { ForwardRef as ReactComponent };